// Unpublished Work © 2026 Deere & Company.

import {
    SET_MERGE_CONTACT_FLOW_ACTIVE,
    HANDLE_MERGE_CONTACT_CHECKBOX_CHANGE,
    RESET_MERGE_CONTACT_FLOW,
    SET_INITIAL_MERGE_CONTACT_ID,
    RESET_CUSTOMER_PROFILE
} from '../../action-list';
import {MergeContact} from '../../state/struct/profile/merge-contact';

const getInitialSelection = (isActive, initialContactId) => {
    if (!isActive) {
        return [];
    }

    return initialContactId ? [initialContactId] : [];
};

const setMergeFlowActive = (state, action) => {
    const initialSelection = getInitialSelection(action.isActive, state.initialMergeContactId);

    return MergeContact.update(state, {
        isMergeBusinessContactsFlowActive: {
            $set: action.isActive
        },
        selectedContactIdsToMerge: {
            $set: initialSelection
        }
    });
};

const handleMergeContactCheckboxChange = (state, action) => {
    const {contactId} = action;
    const isAlreadySelected = state.selectedContactIdsToMerge.includes(contactId);

    return MergeContact.update(state, {
        selectedContactIdsToMerge: {
            $set: isAlreadySelected ?
                state.selectedContactIdsToMerge.filter((id) => id !== contactId) :
                [...state.selectedContactIdsToMerge, contactId]
        }
    });
};

const setInitialMergeContactId = (state, action) => MergeContact.update(state, {
    initialMergeContactId: {
        $set: action.contactId
    }
});

const resetMergeFlow = () => new MergeContact({});

export function mergeContactReducer(state = new MergeContact({}), action = {}) {
    const actionHandlers = {
        [SET_MERGE_CONTACT_FLOW_ACTIVE]: setMergeFlowActive,
        [HANDLE_MERGE_CONTACT_CHECKBOX_CHANGE]: handleMergeContactCheckboxChange,
        [SET_INITIAL_MERGE_CONTACT_ID]: setInitialMergeContactId,
        [RESET_MERGE_CONTACT_FLOW]: resetMergeFlow,
        [RESET_CUSTOMER_PROFILE]: resetMergeFlow
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
